// HeaderWhite.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faShoppingCart, 
  faPhone, 
  faEnvelope,
  faDownload,
  faChevronRight,
  faTimes,
  faHome,
  faInfoCircle,
  faPhoneAlt,
  faPaperPlane,
  faMapMarkerAlt,
  faClock,
  faFire,
  faStar,
  faGift,
  faArrowRight,
  faWandSparkles
} from "@fortawesome/free-solid-svg-icons";
import { Offcanvas, Badge } from "react-bootstrap";
import "./Header.css";
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import myIcon from '../Assets/carticon.png';
import logo from '../Assets/logo.png';

function HeaderWhite() {
  const [cartCount, setCartCount] = useState(0);
  const [storeClose, setStoreClose] = useState(0);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [contactData, setContactData] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("/home");
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();

  // Scroll effect for header
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Set active link based on current path
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        setContactData(body.contact);
        setStoreClose(Number(body.store_close));
      } catch (error) {
        console.error("Error fetching the contact data", error);
      }
    };
    fetchContactData();
  }, []);

  useEffect(() => {
    const count = parseInt(localStorage.getItem("cartCount")) || 0;
    setCartCount(count);

    const handleStorageChange = () => {
      const count = parseInt(localStorage.getItem("cartCount")) || 0;
      setCartCount(count);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const handleDownloadPriceList = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}download_pricelist.php`,
        { responseType: 'blob' }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'PriceList.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Failed to download price list. Please try again later.');
    }
  };

  const navItems = [
    { path: "/home", label: "Home", icon: faHome },
    { path: "/quick", label: "Enquiry", icon: faPaperPlane },
    { path: "/about", label: "About Us", icon: faInfoCircle },
    { path: "/contact", label: "Contact Us", icon: faPhoneAlt },
  ];

  return (
    <div className={`nav-main-white ${isScrolled ? 'scrolled' : ''}`}>
      {/* Colorful Pre-Header - Gradient with Red/Yellow theme */}
      <div className="preheader-colorful">
        <div className="container">
          <div className="preheader-left">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <span>{contactData?.email}</span>
            </div>
            <div className="info-divider"></div>
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <span>{contactData?.phonenumber}</span>
            </div>
          </div>
          
          <div className="preheader-right">
            <div className="timing-item">
              <div className="timing-dot"></div>
              <span>Mon - Sat: 10AM - 6PM</span>
            </div>
            <div className="social-icons">
              <a href="#" className="social-icon facebook" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="social-icon instagram" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="social-icon youtube" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* White Main Header - Clean with Red/Yellow accents */}
      <header className={`main-header-white-bg ${isScrolled ? 'header-shadow-white' : ''}`}>
        <div className="container">
          {/* Mobile Menu Button - MOVED TO LEFT */}
          <button 
            className={`mobile-menu-btn-white ${showOffcanvas ? 'active' : ''}`} 
            onClick={handleShow}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Logo */}
          <Link to="/home" className="logo-wrapper">
            <img src={logo} alt="My Crackers" className="logo-img" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <ul className="nav-list">
              {navItems.map((item) => (
                <li key={item.path} className="nav-item">
                  <Link 
                    to={item.path} 
                    className={`nav-link-white ${activeLink === item.path ? 'active' : ''}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Header Actions */}
          <div className="header-actions">
            <Button 
              className="price-list-btn-premium-white" 
              onClick={handleDownloadPriceList}
            >
              <span className="btn-particles">
                <span className="particle particle-1"></span>
                <span className="particle particle-2"></span>
                <span className="particle particle-3"></span>
                <span className="particle particle-4"></span>
                <span className="particle particle-5"></span>
              </span>
              <span className="btn-content">
                <span className="btn-icon-wrapper">
                  <FontAwesomeIcon icon={faDownload} className="btn-icon" />
                  <FontAwesomeIcon icon={faWandSparkles} className="btn-icon-hover" />
                </span>
                <span className="btn-text">Price List</span>
                <span className="btn-badge">PDF</span>
              </span>
              <span className="btn-ripple"></span>
              <span className="btn-progress">
                <span className="progress-bar"></span>
              </span>
            </Button>
            
            {storeClose === 0 && (
              <Link to="/cart" className="cart-link">
                <div className="cart-wrapper-white">
                  <img src={myIcon} alt="Cart" className="cart-icon" />
                  {cartCount > 0 && (
                    <Badge className="cart-badge-white">
                      {cartCount > 99 ? '99+' : cartCount}
                    </Badge>
                  )}
                </div>
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* Mobile Offcanvas Menu - LEFT SIDE */}
      <Offcanvas 
        show={showOffcanvas} 
        onHide={handleClose} 
        placement="start"
        className="mobile-offcanvas-white"
      >
        <Offcanvas.Header className="offcanvas-header-white">
          <div className="offcanvas-logo">
            <img src={logo} alt="My Crackers" />
          </div>
          <button className="offcanvas-close-white" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Offcanvas.Header>
        <Offcanvas.Body className="offcanvas-body-white">
          <ul className="mobile-nav-list">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className="mobile-nav-link-white" 
                  onClick={handleClose}
                >
                  <FontAwesomeIcon icon={item.icon} />
                  <span>{item.label}</span>
                  <FontAwesomeIcon icon={faChevronRight} className="arrow-icon" />
                </Link>
              </li>
            ))}
          </ul>
          
          <div className="mobile-contact-white">
            <div className="mobile-contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>{contactData?.email}</span>
            </div>
            <div className="mobile-contact-item">
              <FontAwesomeIcon icon={faPhone} />
              <span>{contactData?.phonenumber || "+91 98765 43210"}</span>
            </div>
          </div>

          <Button 
            className="mobile-price-list-white" 
            onClick={() => {
              handleDownloadPriceList();
              handleClose();
            }}
          >
            <FontAwesomeIcon icon={faDownload} />
            Price List
          </Button>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default HeaderWhite;